import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const addGroupToProject = api(async function addGroupToProject({ projectId, name, type }) {
    return mutate(
        gql`
            mutation AddGroupToProject($projectId: String!, $name: String!, $type: String!) {
                addGroupToProject(projectId: $projectId, name: $name, type: $type) {
                    id
                    name
                    type
                }
            }
        `,
        { projectId, name, type },
        { returns: "addGroupToProject" }
    )
})
